<script>
	import ChatCard from "../../molecules/ChatCard/ChatCard.svelte";
    export let loading;
    export let ideas;
</script>

<style src="./ChatCards.scss" lang="scss"></style>

<section class="ChatCards">
    {#if loading}
        <p class="messages">Loading...</p>
    {:else}
        {#if ideas.length}
            {#each ideas as idea}
                <ChatCard {...idea}></ChatCard>
            {/each}
        {:else}
            <p class="messages">You are in no idea chats yet.</p>
        {/if}
    {/if}
</section>